<template>
  <section class="p2 projects section">
    <div class="section-header">
      <div class="title">
        {{$t('HomeText.p2_title')}}
      </div>
      <div class="op">
        <router-link to="/yDNATest">
          {{$t('HomeText.p2_action')}}
        </router-link>
      </div>
    </div>
    <div class="section-content">
      <div class="box">
        <div class="image-wrapper">
          <img src="../../assets/images/home/p2-projects-1.png" alt=""/>
          <div class="title">
            {{$t('HomeText.p2_1')}}
          </div>
        </div>
        <div class="box-c">
          <div class="btn-wrapper">
            <router-link to="/yDNATest">
              {{$t('HomeText.p2_item_action')}}
            </router-link>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="image-wrapper">
          <img src="../../assets/images/home/p2-projects-2.png" alt=""/>
          <div class="title">
            {{$t('HomeText.p2_2')}}
          </div>
        </div>
        <div class="box-c">
          <div class="btn-wrapper">
            <router-link to="/nPrenatalTest">
              {{$t('HomeText.p2_item_action')}}
            </router-link>
          </div>
        </div>
      </div>
      <div class="box">
        <div class="image-wrapper">
          <img src="../../assets/images/home/p2-projects-3.png" alt=""/>
          <div class="title">
            <span>{{$t('HomeText.p2_3')}}</span>
            <span>{{$t('HomeText.p2_3_add_on')}}</span>
          </div>
        </div>
        <div class="box-c">
          <div class="btn-wrapper">
            <router-link to="/paternityTest">
              {{$t('HomeText.p2_item_action')}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    name: "p2-projects",
  }
</script>

<style scoped lang="scss">

  .en .v-home{
    .p2.projects {
      .section-header {
        .title {
          font-size: 1.38vw;
        }

        .op {
          a {
            font-size: 1.25vw;
          }
        }
      }

      .section-content{
        .box{
          .image-wrapper{
            line-height: 1;
            text-align: center;
            .title {
              span:last-child{
                display: block;
              }
            }
          }
        }
      }
    }
  }

  .p2.projects {
    background-color: #fff;

    .section-header {
      height: 7vw;
      display: flex;
      align-items: center;
      background: url('../../assets/images/home/p2-projects-h-bg.png');
      background-size: 100% 100%;

      padding-left: 20%;

      .title {
        width: 38vw;
        height: 4.5vw;
        line-height: 4.5vw;
        background-color: #33bea7;
        border: solid 1px #6ad1c0;
        font-size: 1.56vw;
        font-weight: bold;
        color: #ffffff;
        text-align: center;
      }

      .op {
        width: 19.5vw;
        margin-left: 4%;

        a {
          text-decoration: underline;
          font-size: 1.25vw;
          color: #1bb89d;
        }
      }
    }

    .section-content {
      padding: 5vw 22vw 4vw;
      display: flex;
      justify-content: space-between;
      background: url('../../assets/images/home/p2-bg.png') left bottom no-repeat;
      background-size: auto 100%;

      .box {
        width: 13vw;
        background-color: #ffffff;
        box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.06), inset 0 3px 0 0 rgba(0, 0, 0, 0.03);
        border-radius: 1.04vw;

        .image-wrapper {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-flow: column;
          height: 10.5vw;
          margin-top: 2vw;
          background-color: #fff;
          position: relative;

          img {
            width: 6.5vw;
            height: 7.5vw;
          }

          .title {
            font-size: 0.94vw;
            letter-spacing: -0.03vw;
            span:last-child{
              display: none;
            }
          }
        }

        .box-c {
          padding:.2vw 0 1.5vw;
          text-align: center;
          .btn-wrapper {
            padding: 0.3vw 1vw 0.2vw;
            margin: .5vw 1vw;
            display: inline-block;
            border-radius: 0.67vw;
            background-color: #fff;
            box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.1);

            a {
              font-size: 0.63vw;
              color: #3a99a9;
            }

            &:hover {
              background-color: #38a2b4;

              a {
                color: #ffffff;
              }
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/home/p2-projects.vue